import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/service/apiServices';
import * as $ from 'jquery';
import 'jquery-ui/ui/widgets/button'; // Para os botões
import 'jquery-ui/ui/widgets/dialog'; // Para os diálogos
import 'jquery-ui/ui/widgets/accordion';
import 'flot'; // Importa o Flot

import { Global } from '../../../global';
import { Location } from '@angular/common';

import { catchError } from 'rxjs/operators';

import { AuthService } from '../../../service/auth/auth.service'

import Swal from 'sweetalert2';
declare var dwvjq: any;
declare var dwv: any;

@Component({
  selector: 'app-dicom-viewer',
  templateUrl: './dicom-viewer.component.html',
  styleUrls: ['./dicom-viewer.component.css']
})
export class DicomViewerComponent implements OnInit, OnDestroy {
  imagemExame: any = {};
  uid: any;
  domContentLoaded = false;
  i18nInitialised = false;
  private hasReloaded: boolean = false;
  constructor(
    private route: ActivatedRoute,
    public service: ApiService,
    private router: Router,
    private global: Global,
    private location: Location,
    private authService: AuthService
  ) { }

  ngOnInit() {
    if (!localStorage.getItem('hasReloaded')) {
      localStorage.setItem('hasReloaded', 'true');
      window.location.reload();
    } else {
      this.initializeDwv();
    }
  }

  ngOnDestroy(): void {
    localStorage.removeItem('hasReloaded');
  }

  initializeDwv() {
    console.log("Iniciando a tela");
    localStorage.removeItem('hasReloaded');
    this.uid = this.route.snapshot.paramMap.get('uuid');
    if (this.uid != null) {
      Swal.fire('Favor aguarde')
      Swal.showLoading()
      this.obterExameImagem(this.uid);
    }
  }

  obterExameImagem = (uid) => {
    Swal.fire('Favor aguarde')
    Swal.showLoading();
    this.service.Get(`ExameImagem/${uid}`).then(
      result => {
        this.imagemExame = result;
        this.initGui();
        this.initDicomViewer();
        Swal.close()
      },
      error => {
        if (error.status == 401 || error.error.status == 401) {
          Swal.close()
          this.authService.logoutUser()
        }
        Swal.fire('Erro!', error.error.messagem, 'error')
      });
  }

  goBack() {
    this.location.back();
  }

  initGui = () => {
    let that = this;
    dwvjq = dwvjq || {};
    dwvjq.utils = dwvjq.utils || {};
    dwv.luts.plain = dwv.luts.plain;
    dwv.luts.invPlain = dwv.luts.invPlain;
    dwv.luts.rainbow = dwv.luts.rainbow;
    dwv.luts.hot = dwv.luts.hot;
    dwv.luts.hot_iron = dwv.luts.hot_iron;
    dwv.luts.pet = dwv.luts.pet;
    dwv.luts.hot_metal_blue = dwv.luts.hot_metal_blue;
    dwv.luts.pet_20step = dwv.luts.pet_20step;



    // Default window level presets.
    dwv.defaultpresets = {};
    // Default window level presets for CT.
    dwv.defaultpresets.CT = {
      mediastinum: { center: 40, width: 400 },
      lung: { center: -500, width: 1500 },
      bone: { center: 500, width: 2000 },
      brain: { center: 40, width: 80 },
      head: { center: 90, width: 350 }
    };


    // Toolbox
    dwvjq.gui.ToolboxContainer = function (app, infoController) {
      var base = new dwvjq.gui.Toolbox(app);

      this.setup = function (list) {
        base.setup(list);

        // toolbar

        // open
        var openSpan = document.createElement('span');
        openSpan.className = 'ui-icon ui-icon-plus';
        var open = document.createElement('button');
        open.appendChild(openSpan);
        open.title = dwvjq.i18n.t('basics.open');
        open.onclick = function () {
          that.toggle('#openData');
        };
        // toolbox
        var toolboxSpan = document.createElement('span');
        toolboxSpan.className = 'ui-icon ui-icon-wrench';
        var toolbox = document.createElement('button');
        toolbox.appendChild(toolboxSpan);
        toolbox.title = dwvjq.i18n.t('basics.toolbox');
        toolbox.onclick = function () {
          that.toggle('#dwv-toolList');
        };
        // history
        var historySpan = document.createElement('span');
        historySpan.className = 'ui-icon ui-icon-clipboard';
        var history = document.createElement('button');
        history.appendChild(historySpan);
        history.title = dwvjq.i18n.t('basics.history');
        history.onclick = function () {
          that.toggle('#dwv-history');
        };
        // DICOM tags
        var tagsSpan = document.createElement('span');
        tagsSpan.className = 'ui-icon ui-icon-tag';
        var tags = document.createElement('button');
        tags.appendChild(tagsSpan);
        tags.title = dwvjq.i18n.t('basics.dicomTags');
        tags.onclick = function () {
          that.toggle('#dwv-tags');
        };
        // draw list
        var drawListSpan = document.createElement('span');
        drawListSpan.className = 'ui-icon ui-icon-pencil';
        var drawList = document.createElement('button');
        drawList.appendChild(drawListSpan);
        drawList.title = dwvjq.i18n.t('basics.drawList');
        drawList.onclick = function () {
          that.toggle('#dwv-drawList');
        };
        // image
        var imageSpan = document.createElement('span');
        imageSpan.className = 'ui-icon ui-icon-image';
        var image = document.createElement('button');
        image.appendChild(imageSpan);
        image.title = dwvjq.i18n.t('basics.image');
        image.onclick = function () {
          that.toggle('.layerDialog');
        };
        // info
        var infoSpan = document.createElement('span');
        infoSpan.className = 'ui-icon ui-icon-info';
        var info = document.createElement('button');
        info.appendChild(infoSpan);
        info.title = dwvjq.i18n.t('basics.info');
        info.onclick = function () {
          var infoLayer = document.getElementById('infoLayer');
          dwvjq.html.toggleDisplay(infoLayer);
          infoController.toggleListeners();
        };
        // help
        var helpSpan = document.createElement('span');
        helpSpan.className = 'ui-icon ui-icon-help';
        var help = document.createElement('button');
        help.appendChild(helpSpan);
        help.title = dwvjq.i18n.t('basics.help');
        help.onclick = function () {
          that.toggle('#dwv-help');
        };

        var node = document.getElementById('dwv-toolbar');
        node.innerHTML = '';
        node.appendChild(open);
        node.appendChild(toolbox);
        node.appendChild(history);
        node.appendChild(tags);
        node.appendChild(drawList);
        node.appendChild(image);
        node.appendChild(info);
        node.appendChild(help);

        // apply button style
        $('button').button();

        // save state button
        var saveButton = document.createElement('button');
        saveButton.appendChild(
          document.createTextNode(dwvjq.i18n.t('basics.downloadState'))
        );
        // save state link
        // var toggleSaveState = document.createElement('a');
        // toggleSaveState.onclick = function () {
        //   var blob = new Blob([app.getJsonState()], { type: 'application/json' });
        //   toggleSaveState.href = window.URL.createObjectURL(blob);
        // };
        // toggleSaveState.download = 'state.json';
        // toggleSaveState.id = 'download-state';
        // toggleSaveState.className += 'download-state';
        // toggleSaveState.appendChild(saveButton);
        // // add to openData window
        // node = document.getElementById('openData');
        // node.appendChild(toggleSaveState);
      };

      this.display = function (flag) {
        base.display(flag);
      };

      this.initialise = function () {
        base.initialise();
      };
    };

    // special setup
    dwvjq.gui.setup = function () {
      $('.toggleInfoLayer').button({
        icons: { primary: 'ui-icon-comment' },
        text: false,
        appendTo: '#dwv'
      });
      // create dialogs
      $('#openData').dialog({
        position: { my: 'left top', at: 'left top', of: '#pageMain' },
        appendTo: '#dwv',
        autoOpen: false,
      });
      $('#dwv-toolList').dialog({
        position: { my: 'left top+180', at: 'left top', of: '#pageMain' },
        appendTo: '#dwv',
        autoOpen: false,
      });
      $('#dwv-history').dialog({
        position: { my: 'left top+350', at: 'left top', of: '#pageMain' },
        appendTo: '#dwv',
        autoOpen: false,
      });
      $('#dwv-tags').dialog({
        position: { my: 'right top', at: 'right top', of: '#pageMain' },
        autoOpen: false,
        width: 500,
        height: 590,
        appendTo: '#dwv'
      });
      $('#dwv-drawList').dialog({
        position: { my: 'right top', at: 'right top', of: '#pageMain' },
        autoOpen: false,
        width: 500,
        height: 590,
        appendTo: '#dwv'
      });
      $('#dwv-help').dialog({
        position: { my: 'right top', at: 'right top', of: '#pageMain' },
        autoOpen: false,
        width: 500,
        height: 590,
        appendTo: '#dwv'
      });

      // image dialog
      $('.layerDialog').dialog({
        position: { my: 'center', at: 'center', of: '#pageMain' },
        appendTo: '#dwv',
      });

      setTimeout(that.adjustDialogSize, 100);

      // $("#layerContainer").resizable({ aspectRatio: true });
    };
  }

  adjustDialogSize() {
    // Obtenha o tamanho do .layerContainer
    var containerWidth = $('.layerContainer').width();
    var containerHeight = $('.layerContainer').height();

    // Defina o tamanho do .layerDialog
    $('.layerDialog').dialog({
      position: { my: 'center', at: 'center', of: '#pageMain' },
      appendTo: '#dwv',
      width: containerWidth, // Ajusta a largura para 80% do tamanho do container
      height: containerHeight, // Ajusta a altura para 70% do tamanho do container
      resizable: true
    });
    setTimeout(function () {
      $('.layerDialog').css({
        width: `${containerWidth + 122}px`,
        height: `${containerHeight + 64}px`
      });

      $('.layerGroup').css({
        width: `${containerWidth - 30}px`,
        height: `${containerHeight}px`
      });

    }, 1000); // Ajuste o tempo se necessário
  }

  toggle(dialogId) {
    if ($(dialogId).dialog('isOpen')) {
      $(dialogId).dialog('close');
    } else {
      $(dialogId).dialog('open');
    }
  }

  launchApp() {
    this.startApp();
  }

  initDicomViewer = () => {
    let that = this;
    dwv.decoderScripts.jpeg2000 =
      './assets/decoders/pdfjs/decode-jpeg2000.js';
    dwv.decoderScripts['jpeg-lossless'] =
      './assets/decoders/rii-mango/decode-jpegloss.js';
    dwv.decoderScripts['jpeg-baseline'] =
      './assets/decoders/pdfjs/decode-jpegbaseline.js';
    dwv.decoderScripts.rle =
      './assets/decoders/dwv/decode-rle.js';

    dwvjq.i18n.onInitialised(function () {
      // call next once the overlays are loaded
      var onLoaded = function (data) {
        dwvjq.gui.info.overlayMaps = data;
        that.i18nInitialised = true;
        that.launchApp();
      };
      // load overlay map info
      $.getJSON(dwvjq.i18n.getLocalePath('overlays.json'),
        onLoaded).fail(function () {
          console.log('Using fallback overlays.');
          $.getJSON(dwvjq.i18n.getFallbackLocalePath('overlays.json'), onLoaded);
        });
    });

    // initialise i18n
    dwvjq.i18n.initialise('auto', './assets/resources');

  }

  startApp() {

    let that = this;
    // gui setup
    dwvjq.gui.setup();

    // show dwv version
    // dwvjq.gui.appendVersionHtml('0.9.0-beta.0');

    // application options
    var filterList = ['Threshold', 'Sharpen', 'Sobel'];

    var shapeList = [
      'Arrow',
      'Ruler',
      'Protractor',
      'Rectangle',
      'Roi',
      'Ellipse',
      'Circle',
      'FreeHand'
    ];

    var toolList = {
      Scroll: {},
      Opacity: {},
      WindowLevel: {},
      ZoomAndPan: {},
      Draw: {
        options: shapeList
      },
      Livewire: {},
      Filter: {
        options: filterList
      },
      Floodfill: {}
    };

    // initialise the application
    var options = {
      dataViewConfigs: { '*': [{ divId: 'layerGroup0' }] },
      tools: toolList
    };

    // main application
    var myapp = new dwv.App();
    myapp.init(options);

    // show help
    var isMobile = false;
    dwvjq.gui.appendHelpHtml(
      myapp.getToolboxController().getToolList(),
      isMobile,
      myapp,
      '../assets/resources/help'
    );

    // setup the undo gui
    var undoGui = new dwvjq.gui.Undo(myapp);
    undoGui.setup();

    // setup the dropbox loader
    var dropBoxLoader = new dwvjq.gui.DropboxLoader(myapp);
    dropBoxLoader.init();

    // setup the loadbox gui
    var loadboxGui = new dwvjq.gui.Loadbox(myapp);
    // var loaderList = ['File', 'Url'];
    // if (dwvjq.browser.hasInputDirectory()) {
    //   loaderList.splice(1, 0, 'Folder');
    // }
    // loadboxGui.setup(loaderList);

    // info layer
    var infoController = new dwvjq.gui.info.Controller(myapp);
    infoController.init();

    var infoElement = document.getElementById('infoLayer');
    var infoOverlay = new dwvjq.gui.info.Overlay(infoElement);

    // setup the tool gui
    var toolboxGui = new dwvjq.gui.ToolboxContainer(myapp, infoController);
    toolboxGui.setup(toolList);

    // setup the meta data gui
    var metaDataGui = new dwvjq.gui.MetaData(myapp);

    // setup the draw list gui
    var drawListGui = new dwvjq.gui.DrawList(myapp);
    drawListGui.init();

    // colour map
    var infocm = document.getElementById('infocm');
    var miniColourMap = null;
    if (infocm) {
      miniColourMap = new dwvjq.gui.info.MiniColourMap(infocm, myapp);
    }

    // intensities plot
    var plot = document.getElementById('plot');
    var plotInfo = null;
    if (plot) {
      plotInfo = new dwvjq.gui.info.Plot(plot, myapp);
    }

    // abort shortcut listener
    var abortOnCrtlX = function (event) {
      if (event.ctrlKey && event.keyCode === 88) {
        // crtl-x
        console.log('Abort load received from user (crtl-x).');
        myapp.abortLoad();
      }
    };

    // handle load events
    var nLoadItem = null;
    var nReceivedLoadError = null;
    var nReceivedLoadAbort = null;
    var isFirstRender = null;
    myapp.addEventListener('loadstart', function (event) {
      // reset counts
      nLoadItem = 0;
      nReceivedLoadError = 0;
      nReceivedLoadAbort = 0;
      isFirstRender = true;
      // hide drop box
      dropBoxLoader.showDropbox(false);
      // reset progress bar
      dwvjq.gui.displayProgress(0);
      // update info controller
      if (event.loadtype === 'image') {
        infoController.reset();
      }
      // create colour map (if present)
      if (miniColourMap) {
        miniColourMap.create();
      }
      // allow to cancel via crtl-x
      window.addEventListener('keydown', abortOnCrtlX);
    });
    myapp.addEventListener('loadprogress', function (event) {
      var percent = Math.ceil((event.loaded / event.total) * 100);
      dwvjq.gui.displayProgress(percent);
    });
    myapp.addEventListener('loaditem', function (event) {
      ++nLoadItem;
      // add new meta data to the info controller
      if (event.loadtype === 'image') {
        infoController.onLoadItem(event);
      }
    });
    myapp.addEventListener('renderstart', function (/*event*/) {
      if (isFirstRender) {
        infoController.addEventListener('valuechange', infoOverlay.onDataChange);
      }
    });
    myapp.addEventListener('renderend', function (/*event*/) {
      if (isFirstRender) {
        isFirstRender = false;
        // initialise and display the toolbox on first render
        toolboxGui.initialise();
        toolboxGui.display(true);
      }
    });
    myapp.addEventListener('load', function (/*event*/) {
      // initialise undo gui
      undoGui.setup();
      // update meta data table
      metaDataGui.update(myapp.getMetaData(0));

      // create colour map (if present)
      if (miniColourMap) {
        miniColourMap.create();
      }
      // create plot info (if present)
      if (plotInfo) {
        plotInfo.create();
      }
    });
    myapp.addEventListener('loaderror', function (event) {
      console.error('load error', event);
      ++nReceivedLoadError;
    });
    myapp.addEventListener('loadabort', function (/*event*/) {
      ++nReceivedLoadAbort;
    });
    myapp.addEventListener('loadend', function (/*event*/) {
      // show alert for errors
      if (nReceivedLoadError) {
        var message = 'A load error has ';
        if (nReceivedLoadError > 1) {
          message = nReceivedLoadError + ' load errors have ';
        }
        message += 'occured. See log for details.';
        alert(message);
        // show the drop box if no item were received
        if (!nLoadItem) {
          dropBoxLoader.showDropbox(true);
        }
      }
      // console warn for aborts
      if (nReceivedLoadAbort !== 0) {
        console.warn('Data load was aborted.');
        dropBoxLoader.showDropbox(true);
      }
      // stop listening for crtl-x
      window.removeEventListener('keydown', abortOnCrtlX);
      // hide the progress bar
      dwvjq.gui.displayProgress(100);
    });

    // handle undo/redo
    myapp.addEventListener('undoadd', function (event) {
      undoGui.addCommandToUndoHtml(event.command);
    });
    myapp.addEventListener('undo', function (/*event*/) {
      undoGui.enableLastInUndoHtml(false);
    });
    myapp.addEventListener('redo', function (/*event*/) {
      undoGui.enableLastInUndoHtml(true);
    });

    // handle key events
    myapp.addEventListener('keydown', function (event) {
      myapp.defaultOnKeydown(event);
    });

    // handle window resize
    // WARNING: will fail if the resize happens and the image is not shown
    // (for example resizing while viewing the meta data table)
    window.addEventListener('resize', function () {
      myapp.onResize();
    });

    if (miniColourMap) {
      myapp.addEventListener('wlchange', miniColourMap.update);
      myapp.addEventListener('colourchange', miniColourMap.update);
    }
    if (plotInfo) {
      myapp.addEventListener('wlchange', plotInfo.update);
    }



    const baseUrl = `${that.global.apiUrl}Arquivo/Download/ExameImagem/${that.imagemExame.uuid}/`;
    const dicomFiles = that.imagemExame.arquivos_imagem.map(x => x.nome_arquivo);


    const formattedUrl = that.formatDICOMUrls(baseUrl, dicomFiles);

    var url = `${window.location.href}${formattedUrl}`;

    // possible load from location
    myapp.loadFromUri(url);

    // help
    // TODO Seems accordion only works when at end...
    $('#accordion').accordion({
      collapsible: 'true',
      active: 'false',
      heightStyle: 'content'
    });
  }

  formatDICOMUrls(baseInputUrl, fileNames) {
    if (fileNames.length === 1) {
      const encodedBaseUrl = encodeURIComponent(baseInputUrl);
      const singleFileUrl = `${encodedBaseUrl}${encodeURIComponent(fileNames[0])}`;
      return `?input=${singleFileUrl}&dwvReplaceMode=void`;
    } else {
      const encodedBaseUrl = encodeURIComponent(baseInputUrl + '?');
      const fileParams = fileNames.map(fileName => `file=${fileName}`).join('&');
      const encodedParams = encodeURIComponent(fileParams);
      return `?input=${encodedBaseUrl}${encodedParams}&dwvReplaceMode=void`;
    }
  }

}
